import { PluginReader } from "../../plugin/PluginReader";
import { AbstractVisitor } from "./Visitor";
/**
 * Visitor implementation to assign the parameter (defined as data attributes) to the associated plugin
 *
 * @public
 */
export class AssignPluginParameterVisitor extends AbstractVisitor {
    constructor(node, namespace) {
        super();
        this.node = node;
        this.reader = new PluginReader(namespace);
    }
    visitPlugin(plugin) {
        const param = this.reader.readParameter(this.node, plugin.plugin);
        if (Object.keys(param).length >= 1) {
            plugin.parameter = param;
        }
    }
}
//# sourceMappingURL=AssignPluginParameterVisitor.js.map